import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/views/home/index'
import favorites from '@/views/favorites/favorites'
import about from '@/views/about'
import details from '@/views/details/details'
import demoPlug from '@/views/demoPlug'
import leagues from '@/views/leagues/index'
import privacy from '@/views/policy/privacy'
import terms from '@/views/policy/terms'
import news from '@/views/news/list'
import newsInfo from '@/views/news/info'
import gdt from '@/views/gdt'
import page404 from '@/views/404'
import page500 from '@/views/500'
import team from '@/views/team/index'

Vue.use(VueRouter)

const scrollToTop = () => {
    return { x: 0, y: 0 } // 这里表示目标位置为页面左上角
}

const router = new VueRouter({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition;
        } else {
          return to.hash ? { selector: to.hash } : scrollToTop();
        }
    },
    routes: [
        {
            path: '/',
            name: 'index',
            component: index,
            meta: {
                title: 'index'
            }
        },
        {
            path: '/favorites',
            name: 'favorites',
            component: favorites,
            meta: {
                title: 'favorites'
            }
        },
        {
            path: '/about',
            name: 'about',
            component: about,
            meta: {
                title: 'about'
            }
        },
        // {
        //     path: '/details/:id',
        //     name: 'details',
        //     component: details,
        //     meta: {
        //         title: '比赛内页'
        //     }
        // },
        // {
        //     path: '/details/:id/:title',
        //     name: 'details',
        //     component: details,
        //     meta: {
        //         title: '比赛内页'
        //     }
        // },
        {
            path: '/details/:id/:title/:tab',
            name: 'details',
            component: details,
            meta: {
                title: 'details'
            }
        },
        {
            path: '/demoPlug',
            name: 'demoPlug',
            component: demoPlug,
            meta: {
                title: 'demoPlug'
            }
        },
        {
            path: '/leagues/:id/:tab',
            name: 'leagues',
            component: leagues,
            meta: {
                title: 'leagues'
            }
        },
        {
            path: '/terms',
            name: 'terms',
            component: terms,
            meta: {
                title: 'terms'
            }
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: privacy,
            meta: {
                title: 'privacy'
            }
        },
        {
            path: '/news/:categoryId',
            name: 'news',
            component: news,
            meta: {
                title: 'news'
            }
        },
        {
            path: '/newsInfo/:id/:title',
            name: 'newsInfo',
            component: newsInfo,
            meta: {
                title: 'newsInfo'
            }
        },
        {
            path: '/gdt',
            name: 'gdt',
            component: gdt,
            meta: {
                title: 'gdt'
            }
        },
        {
            path: '/404',
            name: '404',
            component: page404,
            meta: {
                title: '404'
            }
        },
        {
            path: '/500',
            name: '500',
            component: page500,
            meta: {
                title: '500'
            }
        },
        {
            path: '/team/:id/:tab',
            name: 'team',
            component: team,
            meta: {
                title: 'team'
            }
        },
    ]
})
export function createRouter () {
    return router
}



// WEBPACK FOOTER //
// ./src/router/index.js